export const getOption = (devicestatic: [string, number][], color?: string[]) => {
  // 1.處理數據，將數組.map的方式依序遍歷成 echarts 的格式
  const data = devicestatic.map(([label, number]) => {
    const label_uppercase = label.charAt(0).toUpperCase() + label.slice(1);
    return {
      value: number,
      name: label === "up" ? "Good" : label === "na" ? "NA" : label_uppercase,
    };
  });
  // 2.設置圖表的 option
  // Health(運行狀況)、Signal(訊號)、Model(設備)：圓餅圖樣式
  const option = {
    color: color ?? ["#28a745", "#ffc107", "#dc3545", "#343a40", "gray"],
    series: [
      {
        name: "Counts",
        type: "pie",
        radius: ["50%", "80%"],
        label: {
          show: false,
          position: "inside",
          fontSize: 0,
        },
        emphasis: {
          label: {
            show: true,
            fontSize: "20",
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: false,
        },
        data: data,
      },
    ],
  };
  // 3. 返回配置資料
  return option;
};

// firmware 的 label name 需要特殊處理
export const getOption_firmware = (devicestatic: [string, number][], color?: string[]) => {
  // 1.處理數據，將數組.map的方式依序遍歷成 echarts 的格式
  const data = devicestatic.map(([label, number]) => {
    return {
      value: number,
      name: label,
    };
  });
  // 2.設置圖表的 option
  //(Firmware)韌體：圓形圖樣式
  const option = {
    color: color ?? ["#28a745", "#ffc107", "#dc3545", "#343a40", "gray"],
    series: [
      {
        name: "Counts",
        type: "pie",
        radius: ["50%", "80%"],
        label: {
          show: false,
          position: "inside",
          fontSize: 0,
        },
        emphasis: {
          label: {
            show: true,
            fontSize: "20",
            fontWeight: "bold",
            // 根據 name 屬性設置格式化的 label
            formatter: ({ name }: any) => (name.slice(0, 3) === "NaN" ? `NaN` : `${name.slice(0, -17)}`),
          },
        },
        labelLine: {
          show: false,
        },
        data: data,
      },
    ],
  };
  // 3. 返回配置資料
  return option;
};

// 定義一個 圖表點擊事件的類型，描述圖表點擊事件中傳遞的數據結構，
// 這裡表示包含一個data的物件結構，此物件內的 name 字串
export interface ChartClick {
  data?: {
    name?: string;
  };
}
